angular
  .module('app')
  .filter('momentAt', function () {
    const at = function (input) {
      return moment(input).calendar(null, {
        sameDay: 'HH:mm',
        nextDay: '[Tomorrow]',
        nextWeek: '[Next] dddd',
        lastDay: 'DD/MM/YY HH:mm',
        lastWeek: 'DD/MM/YY HH:mm',
        sameElse: 'DD/MM/YY HH:mm',
      });
    };

    return at;
  });
